import { referralsService } from './referralsService'

/**
 * The referrals module façade. No store: the overview and the transaction list are re-fetched by the
 * referrals page and its history dialog, and nothing else in the app reads referral state.
 */
export const useReferrals = () => {
  return {
    referrals: {
      service: referralsService()
    }
  }
}
